export default "<div class=\"loading\"><div class=\"loader lds-ellipsis\"><div></div><div></div><div></div><div></div></div></div>\n"